import { toTitleCase } from "../../../Utility/toTitleCase";

export const processLocationData = (data) => {
    const processedData = data.map((item) => ({
        id: item['Z_BR'],
        name: toTitleCase(item['Z_LOCATION']),
        address1: toTitleCase(item['Z_SHIPTO_STREET1']),
        address2: toTitleCase(item['Z_SHIPTO_STREET2']),
        city: toTitleCase(item['Z_SHIPTO_CITY']),
        state: item['Z_SHIPTO_STATE'],
        zip: item['Z_SHIPTO_ZIP'],
        lat: item['Z_LAT20'],
        lng: item['Z_LON20'],
        taxJur: item['TAX-JUR'],
        taxRate: item['Z_TAX_RATE'],
        phone: item['PHONE'],
        manager: toTitleCase(item['Z_MGR_NAME']),
        asstManager: toTitleCase(item['Z_ASST_MGR_NAME']),
        mondayOpen: item['Z_MON_OPEN'],
        mondayClose: item['Z_MON_CLOSE'],
        tuesdayOpen: item['Z_TUE_OPEN'],
        tuesdayClose: item['Z_TUE_CLOSE'],
        wednesdayOpen: item['Z_WED_OPEN'],  
        wednesdayClose: item['Z_WED_CLOSE'],
        thursdayOpen: item['Z_THU_OPEN'],
        thursdayClose: item['Z_THU_CLOSE'],
        fridayOpen: item['Z_FRI_OPEN'],
        fridayClose: item['Z_FRI_CLOSE'],
        saturdayOpen: item['Z_SAT_OPEN'],
        saturdayClose: item['Z_SAT_CLOSE'],
        email: item['Z_MGR_EMAIL'],
        mobile: item['Z_MGR_MOBILE'],
        DID: item['Z_MGR_DID'],
        asstEmail: item['Z_ASST_MGR_EMAIL'],
        asstMobile: item['Z_ASST_MGR_MOBILE'],
        asstDID: item['Z_ASST_MGR_DID'],
    }))
    return processedData;
}